import React from 'react';
import ChatQuiz from '../components/ChatQuiz';

const QuizPage = () => {
  return (
    <div className="h-full flex flex-col">
      <ChatQuiz />
    </div>
  );
};

export default QuizPage;
